import { render, staticRenderFns } from "./RecordNews.vue?vue&type=template&id=f21c98d6&scoped=true&"
import script from "./RecordNews.vue?vue&type=script&lang=ts&"
export * from "./RecordNews.vue?vue&type=script&lang=ts&"
import style0 from "./RecordNews.vue?vue&type=style&index=0&id=f21c98d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21c98d6",
  null
  
)

export default component.exports